export const mainModulePaths = {
  home: '/',
};
